const metrics = [
  { value: "15+", label: "Years Experience" },
  { value: "500+", label: "Projects Completed" },
  { value: "98%", label: "On-Time Delivery" },
  { value: "100%", label: "Licensed & Insured" },
];

const trustItems = [
  { icon: "ri-shield-check-fill", label: "Fully Licensed & Insured" },
  { icon: "ri-building-2-line", label: "Proven Project Experience" },
  { icon: "ri-medal-line", label: "High-Quality Craftsmanship" },
  { icon: "ri-time-line", label: "Reliable Project Timelines" },
  { icon: "ri-map-pin-2-line", label: "Local Colorado Springs Experts" },
];

export default function TrustBar() {
  return (
    <section className="border-y border-brand-warm-deep">
      {/* Metrics row */}
      <div className="bg-brand-dark">
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {metrics.map((m) => (
              <div key={m.label} className="flex items-center gap-3">
                <p className="font-heading font-bold text-2xl text-brand-amber whitespace-nowrap">{m.value}</p>
                <p className="text-xs font-body text-white/70 leading-snug">{m.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Trust items row */}
      <div className="bg-brand-warm-mid">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-5">
            {trustItems.map((item) => (
              <div key={item.label} className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-xl text-brand-amber`} />
                </div>
                <p className="text-sm font-semibold font-body text-brand-dark leading-snug">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
